module.exports = __webpack_public_path__ + "assets/58197466d4a60929b1b18f456492f794.png";